import { queryOptions } from '@tanstack/react-query';
import { getTasteProfile } from '../endpoints/taste-profile';
import type { TasteProfile } from '@/types/taste-profile';

export const TASTE_PROFILE_QUERY_KEYS = {
  all: ['taste-profile'] as const,
  current: () => [...TASTE_PROFILE_QUERY_KEYS.all, 'current'] as const,
} as const;

export const tasteProfileQueryOptions = () =>
  queryOptions({
    queryKey: TASTE_PROFILE_QUERY_KEYS.current(),
    queryFn: (): Promise<TasteProfile> => getTasteProfile(),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    meta: { persist: false },
  });
